import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { createProfileReport } from '../../services/api';

export default function ReportProfileModal({ profileUsername, onClose }) {
    const [reason, setReason]         = useState('');
    const [details, setDetails]       = useState('');
    const [submitting, setSubmitting] = useState(false);

    const close = () => { if (submitting) return; onClose(); };

    const submit = async () => {
        if (!reason.trim()) { toast.warning('Please select a reason.'); return; }
        setSubmitting(true);
        try {
            const r = await createProfileReport(profileUsername, reason.trim(), details.trim());
            if (r?.success) { toast.success('Report submitted.'); onClose(); }
            else toast.error(r?.message || 'Failed to submit report.');
        } catch { toast.error('Failed to submit report.'); }
        finally { setSubmitting(false); }
    };

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 p-3">
            <div className="w-full max-w-md border border-black/40 bg-offwhite rounded shadow-md overflow-hidden">
                <div className="px-3 py-2 border-b border-black/20 font-bold text-coal">Report Profile</div>
                <div className="p-3 text-sm text-coal flex flex-col gap-2">
                    <div className="text-xs text-coal/70">Reporting: <span className="font-bold text-coal">{profileUsername}</span></div>
                    <select value={reason} onChange={(e) => setReason(e.target.value)} className="w-full border border-black/30 bg-offwhite px-2 py-1 text-sm text-coal rounded outline-none">
                        <option value="">Select a reason...</option>
                        <option value="harassment">Harassment</option>
                        <option value="hate">Hate</option>
                        <option value="spam">Spam</option>
                        <option value="nsfw">NSFW</option>
                        <option value="other">Other</option>
                    </select>
                    <textarea
                        value={details}
                        onChange={(e) => setDetails(e.target.value)}
                        placeholder="Optional details..."
                        className="w-full min-h-[110px] resize-none border border-black/30 bg-offwhite px-2 py-2 text-sm text-coal rounded outline-none"
                    />
                </div>
                <div className="p-2 border-t border-black/20 flex justify-end gap-2 bg-black/5">
                    <button type="button" onClick={close} disabled={submitting} className="px-3 py-1 border border-black/40 bg-offwhite text-coal text-sm rounded hover:bg-black/5 disabled:opacity-60 disabled:cursor-not-allowed">Cancel</button>
                    <button type="button" onClick={submit} disabled={submitting || !reason} className="px-3 py-1 border border-black/40 bg-gold text-coal text-sm rounded hover:brightness-95 disabled:opacity-60 disabled:cursor-not-allowed">Submit</button>
                </div>
            </div>
        </div>
    );
}
